<template>
  <div class="typing-effect-container">
    <span :class="['typing-effect', className]">{{ displayText }}</span>
  </div>
</template>

<script>
export default {
  name: "TypingEffect",
  props: {
    text: {
      type: String,
      required: true,
    },
    speed: {
      type: Number,
      default: 75,
    },
    startDelay: {
      type: Number,
      default: 0,
    },
    loop: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      displayText: "",
      currentIndex: 0,
    };
  },
  computed: {
    className() {
      return this.$attrs.class;
    },
  },
  mounted() {
    setTimeout(() => {
      this.typeText();
    }, this.startDelay);
  },
  methods: {
    typeText() {
      if (this.currentIndex < this.text.length) {
        this.displayText += this.text[this.currentIndex];
        this.currentIndex++;
        setTimeout(this.typeText, this.speed);
      } else if (this.loop) {
        setTimeout(() => {
          this.resetTyping();
          this.typeText();
        }, this.speed); // Pause briefly before restarting
      }
    },
    resetTyping() {
      this.displayText = "";
      this.currentIndex = 0;
    },
  },
};
</script>

<style scoped>
.typing-effect-container {
  display: inline-block;
}

.typing-effect {
  display: inline-block;
}
</style>
